import * as actionTypes from "./actionTypes";

export const setLocale = (dispatch, locale) => {
    if (SUPPORTED_LOCALES.includes(locale)) {
        dispatch(setLocaleSuccess(locale));
    } else {
        dispatch(setLocaleSuccess(DEFAULT_LOCALE));
    }
};

export const setLocaleSuccess = (locale) => {
    return {
        type: actionTypes.SET_LOCALE_SUCCESS,
        payload: locale,
    };
};
